import { Card } from "@/components/ui/card";
import { useAuth } from "@/hooks/auth/auth";
import { normalizeAuthRedirect } from "@/lib/auth-redirect";
import { toast } from "sonner";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useLayoutEffect } from "react";
import { z } from "zod";

const autoLoginSearchSchema = z.object({
  token: z.string().catch(""),
  message: z.string().catch(""),
  redirect: z.string().optional(),
});

const AutoLogin = () => {
  const { token, message, redirect } = Route.useSearch();
  const { setToken, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      setToken(token);
      toast.success(message);
    } else {
      toast.error(message);
      navigate({ to: "/login", search: { redirect: undefined, message: undefined } });
    }
  });

  useLayoutEffect(() => {
    // Add a delay to allow the token to be set before redirecting
    if (isAuthenticated) {
      window.location.href = normalizeAuthRedirect(redirect, window.location.origin);
    }
  }, [isAuthenticated, navigate, redirect]);

  return (
    <div className="flex items-center justify-center flex-1">
      <Card className="mx-auto max-w-md p-6 grid gap-6">
        <div className="flex flex-col items-center gap-4">
          <div className="flex flex-col text-center gap-y-2">
            <h3 className="text-xl font-semibold">Logging In…</h3>
          </div>
          <div className="animate-spin text-primary" />
        </div>
      </Card>
    </div>
  );
};

export const Route = createFileRoute("/account/auto-login")({
  validateSearch: autoLoginSearchSchema,
  component: AutoLogin,
});
